import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';
import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import type * as React from 'react';
import { Link } from 'react-router-dom';

const linkStyle = css`
	align-self: flex-start;
	display: inline-flex;
	align-items: center;
	gap: 0.375rem;
	font-family: ${theme.fonts.body};
	font-weight: ${theme.fontWeights.medium};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.accentDark};
	text-decoration: none;

	&:hover,
	&:focus-visible {
		text-decoration: underline;
	}
`;

type Props = {
	readonly to: string;
	readonly direction?: 'forward' | 'back';
	readonly children: React.ReactNode;
};

/** The accent link of the screen: an arrow points to where it leads. */
const ArrowLink: React.FC<Props> = ({ to, direction = 'forward', children }) => {
	const isBack = direction === 'back';

	return (
		<Link to={to} css={linkStyle}>
			<ConditionalLoader data={isBack}>
				<ArrowLeft size={14} />
			</ConditionalLoader>
			{children}
			<ConditionalLoader data={!isBack}>
				<ArrowRight size={14} />
			</ConditionalLoader>
		</Link>
	);
};

export default ArrowLink;
